import { useState } from "react";
import { Routes, Route, useNavigate } from 'react-router-dom';
import './styles/App.css';
import Home from './pages/Home';
import DownloadHelp from './pages/DownloadHelp';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import IOSReview from './pages/iOSReview';
import ScrollToTop from './components/ScrollToTop';

import logo from './assets/images/phonemousewhite.svg';

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDesktopMenuOpen, setIsDesktopMenuOpen] = useState(false);

  const scrollToSection = (section) => {
    navigate('/', { state: { scrollTo: section } });
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleDesktopMenu = () => {
    setIsDesktopMenuOpen(!isDesktopMenuOpen);
  };

  const navigate = useNavigate();

  return (
    <div className="App">
      <ScrollToTop />
      <nav className="navbar">
        <div className="navbar-left">
          <img src={logo} alt="AirMouse Icon" className="navbar-icon" />
          <span className="navbar-title">AirMouse</span>
        </div>
        
        {/* Mobile hamburger menu button */}
        <button 
          className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        
        {/* Desktop navigation and menu grouped together */}
        <div className="navbar-right">
          <ul className="desktop-nav">
            <li onClick={() => scrollToSection('download')}>Download</li>
            <li onClick={() => scrollToSection('gallery')}>Gallery</li>
            <li onClick={() => scrollToSection('help')}>Help</li>
            <li onClick={() => scrollToSection('faq')}>FAQ</li>
          </ul>

          {/* Desktop 3-bar menu */}
          <div className="desktop-menu-container desktop-only">
            <button
              className={`desktop-menu-toggle ${isDesktopMenuOpen ? 'open' : ''}`}
              onClick={toggleDesktopMenu}
              aria-label="Open menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
            {isDesktopMenuOpen && (
              <div className="desktop-menu-dropdown">
                {/* Temporarily hidden - Download Help page not ready */}
                {/* <button onClick={() => { setIsDesktopMenuOpen(false); navigate('/download-help'); }}>Download Help</button> */}
                <button onClick={() => { setIsDesktopMenuOpen(false); navigate('/terms'); }}>Terms of Service</button>
                <button onClick={() => { setIsDesktopMenuOpen(false); navigate('/privacy'); }}>Privacy Policy</button>
              </div>
            )}
          </div>
        </div>
        
        {/* Mobile navigation */}
        <ul className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
          <li onClick={() => scrollToSection('download')}>Download</li>
          <li onClick={() => scrollToSection('help')}>Help</li>
          <li onClick={() => scrollToSection('faq')}>FAQ</li>
          <li onClick={() => { setIsMobileMenuOpen(false); navigate('/terms'); }}>Terms of Service</li>
          <li onClick={() => { setIsMobileMenuOpen(false); navigate('/privacy'); }}>Privacy Policy</li>
        </ul>
      </nav>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* Temporarily hidden - Download Help page not ready */}
        {/* <Route path="/download-help" element={<DownloadHelp />} /> */}
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/ios-review" element={<IOSReview />} />
      </Routes>

    </div>
  );
}

export default App;

